/*eslint-disable*/
'use strict';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var assign = require('object-assign');
var classie = require('desandro-classie');
var luhn = require('fast-luhn');
require('validatinator');
var Validation = function () {
  function Validation() {
    var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
    _classCallCheck(this, Validation);
    this.config = assign({}, {
      // defaults
      forms: {},
      messages: {},
      fieldsets: {},
      fieldClass: 'lg-validate',
      errorClass: 'lg-validate--error',
      containerClass: 'error-container',
      filledClass: 'error-container--filled',
      inlineLabel: true,
      inlineLabelClass: 'label-show',
      validateOnClick: {},
      realTime: true,
      onError: function onError() {},
      isAjax: {},
      onValidSubmit: function onValidSubmit(event, validForm) {}
    }, config);
    var _config = this.config;
    var forms = _config.forms;
    var messages = _config.messages;
    // Create new validation type - Credit Card Luhn Check

    Validatinator.prototype.validations.luhnCheck = function (fieldValue) {
      if (fieldValue === '') {
        return true;
      } else {
        return luhn(fieldValue);
      }
    };
    Validatinator.prototype.messages.validationMessages.luhnCheck = 'Please enter a valid card number';
    this.validatinator = new Validatinator(forms, messages);
  }
  _createClass(Validation, [{
    key: 'bindEvents',
    value: function bindEvents() {
      this.FormValidation();
    }
  }, {
    key: 'FormValidation',
    value: function FormValidation() {
      var _config2 = this.config;
      var forms = _config2.forms;
      var fieldClass = _config2.fieldClass;
      var realTime = _config2.realTime;
      var onValidSubmit = _config2.onValidSubmit;
      var validateOnClick = _config2.validateOnClick;
      var isAjax = _config2.isAjax;
      var formSubmitAttempted = false;
      var _this = this;
      for (var formName in forms) {
        if (forms.hasOwnProperty(formName)) {
          var formKey;
          var clickKey;
          var ajaxKey;
          var ajaxClickKey;
          (function () {
            // get the property of each key
            var myForm = document.querySelector('form[name="' + formName + '"]');
            if (myForm) {
              var formFields = Array.from(myForm.querySelectorAll('.' + fieldClass));
              if (realTime == true) {
                if (formFields.length > 0) {
                  formFields.forEach(function (field) {
                    var isFieldModified = false;
                    var name = formName;
                    if (field.type === 'radio') {
                      (function () {
                        var radioName = field.name;
                        var allRadio = document.querySelectorAll('[name="' + radioName + '"]');
                        field.addEventListener('click', function () {
                          if (allRadio.length) {
                            allRadio.forEach(function (radio) {
                              if ("createEvent" in document) {
                                var evt = document.createEvent("HTMLEvents");
                                evt.initEvent("change", false, true);
                                radio.dispatchEvent(evt);
                              } else {
                                radio.fireEvent("onchange");
                              }
                            });
                          }
                        });
                        field.addEventListener('change', function () {
                          _this.FieldValidator(name, field);
                          isFieldModified = true;
                        });
                      })();
                    } else {
                      field.addEventListener('change', function () {
                        _this.FieldValidator(name, field);
                        isFieldModified = true;
                      });
                    }
                    field.addEventListener('keyup', function () {
                      if (isFieldModified === true || formSubmitAttempted === true) {
                        _this.FieldValidator(name, field);
                      }
                    });
                  });
                }
              }
              for (formKey in forms) {
                if (forms.hasOwnProperty(formKey)) {
                  (function () {
                    var currentFormName = formKey;
                    var eventType = 'submit';
                    var eventElem = myForm;
                    if (currentFormName === formName) {
                      for (clickKey in validateOnClick) {
                        if (validateOnClick.hasOwnProperty(clickKey)) {
                          if (clickKey === currentFormName) {
                            eventType = 'click';
                            eventElem = document.getElementById(validateOnClick[clickKey]);
                          }
                        }
                      }
                      eventElem.addEventListener(eventType, function (e) {
                        formSubmitAttempted = true;
                        var targetForm = e.currentTarget;
                        if (eventType === 'click') {
                          targetForm = myForm;
                        }
                        if (_this.validatinator.passes(currentFormName)) {
                          onValidSubmit(e, targetForm);
                        } else {
                          e.preventDefault();
                          _this.FormErrors(_this.validatinator.errors, targetForm);
                        }
                      });
                    }
                  })();
                }
              }
              for (ajaxKey in isAjax) {
                if (isAjax.hasOwnProperty(ajaxKey)) {
                  (function () {
                    var ajaxFormName = ajaxKey;
                    var ajaxEventType = 'submit';
                    var ajaxEventElem = myForm;
                    if (ajaxFormName === formName) {
                      for (ajaxClickKey in validateOnClick) {
                        if (validateOnClick.hasOwnProperty(ajaxClickKey)) {
                          if (ajaxClickKey === ajaxFormName) {
                            ajaxEventType = 'click';
                            ajaxEventElem = document.getElementById(validateOnClick[ajaxClickKey]);
                          }
                        }
                      }
                      ajaxEventElem.addEventListener(ajaxEventType, function (e) {
                        var targetForm = e.currentTarget;
                        if (ajaxEventType === 'click') {
                          targetForm = myForm;
                        }
                        if (!_this.validatinator.fails(ajaxFormName)) {
                          isAjax[ajaxFormName](e, targetForm);
                        }
                      });
                    }
                  })();
                }
              }
            }
          })();
        }
      }
    }
  }, {
    key: 'FieldValidator',
    value: function FieldValidator(formName, field) {
      if (this.validatinator.fails(formName)) {
        this.FieldErrors(this.validatinator.errors, field, formName);
      }
      if (this.validatinator.passes(formName)) {
        this.FieldErrors(this.validatinator.errors, field, formName);
      }
    }
  }, {
    key: 'FieldErrors',
    value: function FieldErrors(error, field, form) {
      var errorClass = this.config.errorClass;
      var formField = field.name;
      var errorContainer = field.nextElementSibling;
      this.CreateErrorContainer(errorContainer, field, errorClass);
      this.CreateErrorMessages(error, errorContainer, errorClass, field, formField);
      this.FormFieldSets(document.querySelector('[name="' + form + '"]'));
    }
  }, {
    key: 'FormErrors',
    value: function FormErrors(error, form) {
      var _this2 = this;
      var _config3 = this.config;
      var errorClass = _config3.errorClass;
      var fieldClass = _config3.fieldClass;
      var onError = _config3.onError;
      var formFields = Array.from(form.querySelectorAll('.' + fieldClass));
      onError(error);
      formFields.forEach(function (el) {
        var errorContainer = el.nextElementSibling;
        _this2.CreateErrorContainer(errorContainer, el, errorClass);
        _this2.CreateErrorMessages(error, errorContainer, errorClass, el, el.name);
      });
      this.FormFieldSets(form);
    }
  }, {
    key: 'CreateErrorMessages',
    value: function CreateErrorMessages(error, container, errorClass, element) {
      var _config4 = this.config;
      var filledClass = _config4.filledClass;
      var inlineLabel = _config4.inlineLabel;
      var inlineLabelClass = _config4.inlineLabelClass;
      for (var key in error) {
        if (error.hasOwnProperty(key)) {
          for (var errorField in error[key]) {
            if (error[key].hasOwnProperty(errorField)) {
              var fieldError = error[key];
              var fieldErrors = fieldError[errorField];
              if (errorField === element.getAttribute('Name')) {
                var errorArray = [];
                for (var singleError in fieldErrors) {
                  if (fieldErrors.hasOwnProperty(singleError)) {
                    errorArray.push(fieldErrors[singleError] + '<br />');
                  }
                }
                var errorText = errorArray.join('');
                container = element.nextElementSibling;

                // Add error class
                classie.add(element, errorClass);
                if (inlineLabel) {
                  classie.remove(element.previousElementSibling, inlineLabelClass);
                }

                // Add error message and filled class
                container.innerHTML = '<p>' + errorText + '</p>';
                classie.add(container, filledClass);
                container.style.display = 'block';
              }
            }
          }
        }
      }
    }
  }, {
    key: 'CreateErrorContainer',
    value: function CreateErrorContainer(container, element, errorClass) {
      var _config5 = this.config;
      var containerClass = _config5.containerClass;
      var filledClass = _config5.filledClass;
      // If an error container already exists

      if (container !== null && classie.has(container, containerClass)) {
        // Remove error message
        container.innerHTML = '';
        container.style.display = 'none';

        // If error container has filled class
        if (classie.has(container, filledClass)) {
          // Remove filled class
          classie.remove(container, filledClass);
        }
      } else {
        // Create an error container
        container = document.createElement('div');
        classie.add(container, containerClass);
        element.parentNode.insertBefore(container, element.nextSibling);
        container.style.display = 'none';
      }

      // If field has error class
      if (classie.has(element, errorClass)) {
        // Remove error class
        classie.remove(element, errorClass);
      }
    }
  }, {
    key: 'FormFieldSets',
    value: function FormFieldSets(form) {
      var _this3 = this;
      var _config6 = this.config;
      var fieldsets = _config6.fieldsets;
      var errorClass = _config6.errorClass;
      for (var fieldsetKey in fieldsets) {
        if (fieldsets.hasOwnProperty(fieldsetKey)) {
          if (fieldsetKey === form.name) {
            var fieldsetFields = fieldsets[fieldsetKey];
            fieldsetFields.forEach(function (fieldset) {
              var group = document.getElementById(fieldset);
              var errorContainer = group.lastElementChild;
              _this3.CreateFieldsetErrorContainer(errorContainer, group, errorClass);
              _this3.HandleFieldsetErrors(group);
            });
          }
        }
      }
    }
  }, {
    key: 'CreateFieldsetErrorContainer',
    value: function CreateFieldsetErrorContainer(container, element) {
      var _config7 = this.config;
      var containerClass = _config7.containerClass;
      var filledClass = _config7.filledClass;
      // If an error container already exists

      if (container !== null && classie.has(container, containerClass + '--fieldset')) {
        // Remove error message
        container.innerHTML = '';

        // If error container has filled class
        if (classie.has(container, filledClass)) {
          // Remove filled class
          classie.remove(container, filledClass);
        }
      } else {
        // Create an error container
        container = document.createElement('div');
        classie.add(container, containerClass);
        classie.add(container, containerClass + '--fieldset');
        element.appendChild(container);
      }
    }
  }, {
    key: 'HandleFieldsetErrors',
    value: function HandleFieldsetErrors(fieldsetGroup) {
      var _config8 = this.config;
      var containerClass = _config8.containerClass;
      var filledClass = _config8.filledClass;
      var fieldsetErrors = Array.from(fieldsetGroup.querySelectorAll('.' + filledClass));
      var fieldsetErrorContainer = fieldsetGroup.querySelector('.' + containerClass + '--fieldset');
      var firstError = true;
      var count = 0;
      if (fieldsetErrors.length) {
        fieldsetErrors.forEach(function (error) {
          var errorHTML = error.innerHTML;
          if (classie.has(error, filledClass)) {
            count += 1;
          }
          if (classie.has(error, filledClass) && firstError) {
            firstError = false;
            fieldsetErrorContainer.innerHTML = errorHTML;
            classie.add(fieldsetGroup, 'fieldset--error');
            fieldsetErrorContainer.style.display = 'block';
          }
          error.style.display = 'none';
        });
      }
      if (firstError === true && count === 0) {
        fieldsetErrorContainer.innerHTML = '';
        classie.remove(fieldsetGroup, 'fieldset--error');
      }
    }
  }]);
  return Validation;
}();
module.exports = Validation;